import { BASE_FLOW_BUILDER_API_URL } from 'components/flowBuilder/constants';

export const FILE_UPLOAD_URL = 'v2/files/upload/';
export const FLOWS_INFO = '/v2/flowbuilder/flows/[guid]/info/';
export const IMAGE_UPLOAD_URL = 'image/upload';
export const MESSAGE_FIELD_PREVIEW = `${BASE_FLOW_BUILDER_API_URL}actions/field/preview/`;
export const RCS_COVERAGE = '/v2/messaging/rcs_coverage';
export const SEND_MESSAGE_TEST_API_URL = `${BASE_FLOW_BUILDER_API_URL}actions/message/test/`;

// TODO: Move api routes down here into const
const Routes = {
  FLOWS_REQUIRES_NEW_VERSION: `v2/flowbuilder/flows/[guid]/requires_new_version/`,
} as const;

export default Routes;
